import React, { useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import ReactDOMServer from "react-dom/server";
import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import AppModal from "../../../../components/Modal/AppModal";
import Translator from "../../../../components/helpers/Translator";
import { axiosPath } from "../../../../../routing/helpers/router";
import { Formik } from "formik";
import { useParams } from "react-router-dom";
import * as currentPageAction from "@/store/actions/currentPageAction";

const IntelligenceModalProfileLoad = () => {
  const { moduleBridgeHex } = useParams();
  const [showLoadProfileModal, setShowLoadProfileModal] = useState(false);

  const dispatch = useDispatch();
  const intelligenceProfiles = useSelector(
    (state) => state.currentPage?.intelligenceProfiles,
  );

  const handleLoadProfile = async (values, { resetForm }) => {
    if (values.mode === "delete" || values.mode === "load") {
      await axios
        .post(axiosPath("api_r_user_m_intelligence_crudProfile"), {
          form: values,
          moduleBridgeHex,
        })
        .then(({ data }) => {
          dispatch(
            currentPageAction.change(
              "intelligenceProfiles",
              data.intelligenceProfiles,
              true,
            ),
          );
          resetForm();
          setShowLoadProfileModal(false);

          // if (values.mode === "load") {
          //   const newDefaultReportValues = {};
          //   Object.keys(response.data.loadedProfile).forEach((key) => {
          //     newDefaultReportValues[key] = response.data.loadedProfile[key];
          //   });
          //   setDefaultReportValues(newDefaultReportValues);
        });
    }
  };

  return (
    <>
      <div className="card-header">
        <Translator file="module-intelligence" name="module.int.settings" />
        <small
          className="float-right text-info pointer"
          onClick={() => setShowLoadProfileModal(true)}
        >
          <Translator file="module-intelligence" name="profiles" /> (
          {intelligenceProfiles.length})
        </small>
      </div>
      <AppModal
        show={showLoadProfileModal}
        title={ReactDOMServer.renderToString(
          <Translator file="module-intelligence" name="profiles" />,
        )}
        onClose={() => setShowLoadProfileModal(false)}
      >
        <Formik
          initialValues={{
            profile: "",
          }}
          onSubmit={handleLoadProfile}
        >
          {({ setFieldValue, handleSubmit, values }) => (
            <>
              <div className="row">
                {intelligenceProfiles && intelligenceProfiles.length > 0 ? (
                  <div className="col-lg-12">
                    <AppMultiSelect
                      options={intelligenceProfiles}
                      title={ReactDOMServer.renderToString(
                        <Translator file="module-intelligence" name="name" />,
                      )}
                      icon={<AppRemixIcon icon="draft" />}
                      onChange={(e) => setFieldValue("profile", e)}
                      placeholder={ReactDOMServer.renderToString(
                        <Translator
                          file="module-intelligence"
                          name="select.profile"
                        />,
                      )}
                      value={values.profile}
                      setLabelField="name"
                      setValueField="id"
                    />
                  </div>
                ) : (
                  <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                    <div className="form-control mb-3">
                      <Translator
                        file="module-intelligence"
                        name="no.profiles"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-12 mt-4">
                  <small
                    className="text-danger float-right pointer"
                    onClick={() => {
                      setFieldValue("mode", "delete");
                      handleSubmit();
                    }}
                  >
                    <AppRemixIcon icon="delete-bin" />{" "}
                    <Translator
                      file="module-intelligence"
                      name="delete.selected.profile"
                    />
                  </small>
                </div>
              </div>
            </>
          )}
        </Formik>
      </AppModal>
    </>
  );
};

export default IntelligenceModalProfileLoad;
